import { addAmounts, type Amount, zeroAmount } from '@orus.eu/amount'

type RecoverableInvoiceGroupLike = {
  invoices: readonly { invoiceId: string; amount: Amount }[]
}

export function computeRecoveryTotal(
  groups: readonly RecoverableInvoiceGroupLike[],
  requestedInvoiceIds: readonly string[],
): { matchedInvoiceIds: string[]; total: Amount } {
  const requested = new Set(requestedInvoiceIds)
  const matched = groups.flatMap((group) => group.invoices).filter((invoice) => requested.has(invoice.invoiceId))

  return {
    matchedInvoiceIds: matched.map((invoice) => invoice.invoiceId),
    total: matched.length === 0 ? zeroAmount : addAmounts(...matched.map((invoice) => invoice.amount)),
  }
}
